import { useNavigate } from "react-router-dom";
import Clickable from "../components/clickable.";
import images from "../constants/images";
import Page from "../components/page";
import { useState } from "react";
import api from "../functions/api";
import toast from "../functions/toast";

const EmployeeAdd = () => {
    const [employeeName, setEmployeeName] = useState("");
    const [salary, setSalary] = useState(0);
    const [dubleMachineSalary, setDubleMachineSalary] = useState(0);

    const addEmployee = async () => {
        try {
            await api.post("/add-employee", {
                name: employeeName,
                serialNum: 1,
                singleMachineSalary: salary,
                dubleMachineSalary,
            });
            toast.success("Employee added successfully");
            navigate(-1);
        } catch (err) {
            console.log("🚀 ~ addEmployee ~ err:", err);
        }
    };

    const navigate = useNavigate();

    const handleCancel = () => {
        navigate(-1);
    };

    return (
        <Page title="Add Employees">
            <div className="add-machine">
                <div className="style-0">
                    <div className="style-5">
                        <div className="style-6">Name</div>

                        <div className="style-8">
                            <input
                                className="style-11"
                                placeholder="Employee Name"
                                value={employeeName}
                                onChange={(e) =>
                                    setEmployeeName(e.currentTarget.value)
                                }
                            />
                        </div>
                    </div>

                    <div className="style-5">
                        <div className="style-6">Salary (Single Machine)</div>

                        <div className="style-8">
                            <input
                                className="style-11"
                                inputMode="numeric"
                                value={salary || null}
                                onChange={(e) =>
                                    setSalary(e.currentTarget.value)
                                }
                            />
                        </div>
                    </div>

                    <div className="style-5">
                        <div className="style-6">Salary (Double Machine)</div>

                        <div className="style-8">
                            <input
                                className="style-11"
                                inputMode="numeric"
                                value={dubleMachineSalary || null}
                                onChange={(e) =>
                                    setDubleMachineSalary(e.currentTarget.value)
                                }
                            />
                        </div>
                    </div>
                </div>

                <div className="save-button">
                    <Clickable className="cancel-b" onClick={handleCancel}>
                        <img src={images.close} className="cancel-icon" />
                        Cancel
                    </Clickable>
                    <Clickable className="save-b" onClick={addEmployee}>
                        <img src={images.save} className="cancel-icon" />
                        Save
                    </Clickable>
                </div>
            </div>
        </Page>
    );
};

export default EmployeeAdd;
